module.exports = __webpack_public_path__ + "img/ico-hgsc.d92d4b9d.png";